import request from '../utils/axios';

export const getUsers = (params) => {
  return request({ method: 'GET', url: '/users', params });
};

export const createUsers = (data) => {
  return request({ method: 'POST', url: '/users', data });
};

export const editUser = (id, data) => {
  return request({ method: 'PUT', url: `/users/${id}`, data });
};

export const deleteUser = (id) => {
  return request({ method: 'DELETE', url: `/users/${id}` });
};

export const assignRole = (data) => {
  return request({ method: 'POST', url: '/roles/assign', data });
};

export const unassignRole = (data) => {
  return request({ method: 'POST', url: '/roles/unassign', data });
};
